export const translateModel = (translate, lang) => {
  if (!translate) return '';

  return (
    translate[lang] ||
    translate[Object.keys(translate).filter((key) => translate[key])[0]]
  );
};
